import api from './api';

export type FirmwareUpdateItem = {
  id: number;
  nombre: string;
  tipo: string;
  generacion: number;
  online: boolean;
  ip: string;
  current_version: string;
  target_version: string;
};

export type FirmwareJobItem = {
  id: number;
  nombre: string;
  tipo: string;
  generacion: number;
  online: boolean;
  current_version: string;
  target_version: string;
  status: string;
  error: string | null;
  lote: number;
};

export type FirmwareJob = {
  id: number;
  status: string;
  created_at: string | null;
  updated_at: string | null;
  total: number;
  sent: number;
  ok: number;
  failed: number;
  skipped: number;
  items: FirmwareJobItem[];
};

export async function fetchFirmwareUpdates(): Promise<{
  updates: FirmwareUpdateItem[];
  count: number;
  job: FirmwareJob | null;
}> {
  const response = await api.get('/firmware/updates');
  return response.data;
}

export async function fetchFirmwareJob(): Promise<FirmwareJob | null> {
  const response = await api.get('/firmware/job');
  return response.data?.job ?? null;
}

export async function startFirmwareUpdate(deviceIds: number[]): Promise<FirmwareJob> {
  const response = await api.post('/firmware/update', { device_ids: deviceIds });
  return response.data.job;
}
